import { render, staticRenderFns } from "./detail-component-dossier-lot-summary.vue?vue&type=template&id=0a56317f&scoped=true"
import script from "./detail-component-dossier-lot-summary.vue?vue&type=script&lang=ts"
export * from "./detail-component-dossier-lot-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a56317f",
  null
  
)

export default component.exports